// @flow
import { connect } from 'react-redux';

import CompetitionsInternationalesClassement from 'components/competitionsInternationales/competitionsInternationalesClassement';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/competitionsInternationales/competitionsInternationalesHome';

export default connect((state: StateType): StateProps => ({
  data: state.competitionsInternationalesState.data,
  status: state.competitionsInternationalesState.status
}))(CompetitionsInternationalesClassement);
